import React from 'react'
import "./Loading.css"
import {Rings} from "react-loader-spinner"

export default function Loading() {
  return (
    <div className='loading-container' >
        <Rings color='white' width={100} height={100} />
    </div>
  )
}
